import React from 'react';
import styles from '../Home.module.css';

/**
 * A miniature of a delivered client-gallery hero — the visual proof of
 * the hand-off chapter. It is a static illustration, not a link: the
 * one working "Open the demo gallery" CTA lives in the Client galleries
 * band below, so the demo is pitched exactly once.
 */
const GalleryCard: React.FC<{ className?: string }> = ({ className }) => (
  <div className={`${styles.galleryCard} ${className ?? ''}`}>
    <img
      src="/categories/couple.webp"
      alt=""
      className={styles.galleryCardImg}
      loading="lazy"
      decoding="async"
      width="480"
      height="620"
    />
    <div className={styles.galleryCardScrim} aria-hidden="true" />
    <div className={styles.galleryCardChrome} aria-hidden="true">
      <p className={styles.galleryCardEyebrow}>Client gallery</p>
      <p className={styles.galleryCardTitle}>Aisha &amp; Dev</p>
      <p className={styles.galleryCardFolio}>June 2026 · 18 photographs</p>
      <span className={styles.galleryCardLink}>View Gallery</span>
    </div>
  </div>
);

export default GalleryCard;
